import React from 'react'

const BIstrastegies = () => {
  return (
    <div>BIstrastegies</div>
  )
}

export default BIstrastegies